/* eslint-disable no-unused-vars */
import Vue from "vue";
import Router from 'vue-router'
import VueGtag from "vue-gtag";
import store from '@/store'
import _ from 'lodash'
import routes from './routes'
import UserRepository from '@/repositories/repository-user'
import UserRepositoryMock from '@/repositories/mock/repository-user'
import CONST_DATA from '@/mixins/const/constData'
import axios from 'axios';
import StayRepository from '@/repositories/repository-stay'
import StayRepositoryMock from '@/repositories/mock/repository-stay'

const UserRepo = process.env.NODE_ENV === CONST_DATA.ENV.LOCAL ? UserRepositoryMock : UserRepository
const StayRepo = process.env.VUE_APP_DEV_MODE === CONST_DATA.ENV.LOCAL ? StayRepositoryMock : StayRepository;

Vue.use(Router);

const router = new Router({
  mode: 'history',
  scrollBehavior(to, from) {
    if (to.path === from.path) {
      return
    }
    return { x: 0, y: 0 }
  },
  routes
})

router.beforeEach(async (to, from, next) => {
  // CRM汎用独自対応↓↓↓
  // TODO:(仮対応)ログイン認証が出来るようになってから再確認すること
  // ログイン認証のためbo-code,company_cdを取得
  let url = new URL(window.location.href);
  let params = url.searchParams;
  let boCode = params.get("bo-code");
  let companyCd = params.get("company_cd");
  // ストアに保存
  // 他のサブドメインからboCodeの情報がない場合(Cookie参照)
  if (!store.getters["params/get"].boCode) {
    // URLにboCodeの情報がある場合
    if (boCode) {
      store.commit("params/boCode", boCode);
    } else {
      store.commit("params/boCode", "CR");
    }
  }
  if(companyCd){
    store.commit("params/companyCd", companyCd);
  }
  // CRM汎用独自対応↑↑↑
  router['referrer'] = from;

  if ( to.name !== 'sessionTimeOut' && to.name !== 'callback' ) {
    sessionStorage.setItem('currentHref', process.env.VUE_APP_BASE_URL + to.fullPath)
  }

  //required login check
  const isSkipAuth = ['/pages/no-valid-plan-menu', '/pages/not-found', '/pages/internal-error'].includes(to.path)

  const userInfo = store.getters['auth/get'].user
  if (userInfo) {
    store.commit('auth/setLoggedIn', true)
    next(true)
    return
  } else {
    // CRM汎用独自対応↓↓↓
    // 未ログイン時にセッションタイムアウト画面直打ちの対応
    if (to.name === 'sessionTimeOut') {
      window.location.href = process.env.VUE_APP_TOP_DOMAIN + `/session-time-out`;
      return
    } else if (to.path === '/authorization/cb' || to.path === '/authorization/contract-error' || to.path === '/logout') { // #71711 CRM独自対応として/authorization/contract-errorの分岐を追加
      next(true)
      return
    }
    //  CHECK AUTHEN ON FIRST TIME LOAD PAGE
    try {
      let contractInfoAPI = await UserRepo.contractInfo(store.getters["params/get"].boCode,store.getters["params/get"].companyCd);
      
      const contracts = contractInfoAPI?.data?.contractInfo
      // CRM汎用独自対応↑↑↑
      // last selected contract in previous logged in
      const lastSelectedContract = store.getters['persist/get']._lastSelectedContract
      let selectedContract = null
      if (contracts.length > 1 && lastSelectedContract) {
        // select last selected contract
        selectedContract = _.get(
          contracts.filter((c) => c.customerNo === lastSelectedContract.customerNo),
          '[0]'
        )
      } else if (contracts.length >= 1) {
        // auto select if have only 1 contract
        selectedContract = contracts[0]
      }
      if (!selectedContract) {
        // set not logged in
        if (isSkipAuth) {
          // 認証不要ページの場合はそのままreturnする
          next(true)
          return
        }
        store.commit('auth/setLoggedIn', false)
        if(to.name !== 'plan_details') {
          next(true)
        }
      } else {
        // CRM独自対応
        sessionStorage.setItem('companyCd', selectedContract.companyCd);
        // get user info
        // CRM汎用独自対応
        let userInfoAPI = await UserRepo.postUser(store.getters["params/get"].boCode);
        const userInfo = {
          ...userInfoAPI.data,
          contract: selectedContract,
          isCompleteFirstLogin: undefined
        }
        // save user info to state
        store.commit('auth/set', { user: userInfo })
        store.commit('auth/setLoggedIn', true)
        // CRM独自対応
        // window.dataLayer.push({
        //   event: "braze_login",
        //   customerNo: selectedContract.customerNo,
        // });
        next(true)
      }
    } catch (error) {
      if (isSkipAuth) {
        next(true)
        return
      }
      store.commit('auth/setLoggedIn', false)
      if(to.name !== 'plan_details') {
        next(true)
      }
    }
    // CRM汎用独自対応↓↓↓
    // if (
    //   process.env.NODE_ENV !== CONST_DATA.ENV.LOCAL &&
    //   to.meta.requiredLogin &&
    //   !store.getters['auth/get'].user
    // ) {
    //   if(to.name === 'plan_details'){
    //     localStorage.setItem('currentHref', process.env.VUE_APP_BASE_URL + to.fullPath)
    //     return window.location = (`${process.env.VUE_APP_API_URL}/v1/stay/login`)
    //   }
    //   else{
    //     store.commit('auth/setLoggedIn', true)
    //     window.location.href = process.env.VUE_APP_TOP_DOMAIN
    //     return
    //   }
    // }
    }
  // 未ログイン時かつauthorizationに遷移以外はログイン画面に遷移
  if (!store.getters["auth/get"].user && to.path != "/authorization/cb" && to.path !== '/authorization/contract-error' && to.name != "sessionTimeOut" && to.path != "/logout") { // #71711 CRM独自対応として/authorization/contract-errorの分岐を追加
    // セッションタイムアウト画面に遷移の際は top のセッションタイムアウト画面に遷移
    // セッション切れの遷移で LIFE, STAY から TOP に遷移する
    if (document.referrer.indexOf(location.hostname) !== -1 ||
      document.referrer.indexOf(process.env.VUE_APP_LIFE_DOMAIN) !== -1 ||
      document.referrer.indexOf(process.env.VUE_APP_STAY_DOMAIN) !== -1
    ) {
      window.location.href = process.env.VUE_APP_TOP_DOMAIN + `/session-time-out`;
      return false;
    }
    const storeBoCode = store.getters["params/get"].boCode;
    window.location.href = process.env.VUE_APP_AUTHORIZATION + `/v1/stay/login?bo-code=${storeBoCode}`;
    return false;
  } else {
    // ↓↓↓↓個人課金対象判断処理（ログインしている場合のみ実施する）↓↓↓↓
    if (store.getters["auth/get"].user){

      let mustHavePayment = store.getters["personalPayment/getMustHavePayment"];
      if(mustHavePayment == null){//storeに支払方法設定要否判断情報がない場合、BFFから取得する
        const res = await StayRepo.getMustHavePaymentCheck();
        if(res.status == 200){
          mustHavePayment = res.data.isSetUpPaymentMethod;
          store.commit("personalPayment/setMustHavePayment", mustHavePayment);//支払方法設定要否判断情報をstoreに保存
        }
      }
      //個人課金対象アカウントで支払方法未設定の場合
      console.log("mustHavePayment",mustHavePayment);
      if(mustHavePayment && to.meta.requirePersonalPay != false){
        window.location.href = process.env.VUE_APP_TOP_DOMAIN + "/select-payment"; //支払方法選択画面に遷移
        return false;
      }
    }
    // ↑↑↑↑個人課金対象判断処理↑↑↑↑
    next();
  }
  // CRM汎用独自対応↑↑↑
})

router.beforeEach((to, from, next) => {
  if (to.path === '/authorization/cb' || to.path === '/authorization/contract-error' || to.path === '/v1/stay/login' || to.path === '/v1/stay/logout'){ // #71711 CRM独自対応として/authorization/contract-errorの分岐を追加
    next();
  } else if (to.path === "/authorization/redirect"){
    window.location.href = process.env.VUE_APP_TOP_DOMAIN;
  }
  else {
    // サーバーのチェックAPIを呼び出す
    // CRM汎用独自対応（暫定対応）
    axios.get(process.env.VUE_APP_AUTHORIZATION + '/v1/ssocheck/CR/', {withCredentials: true})
    .then(response => {
      // SSOチェックの応答に基づいて何か処理をする場合
      switch (response.status) {
        case 200:
          // 成功時の処理
          next()
          break;
        default:
          next()
      }
    })
    .catch(error => {
      switch (error.response.status) {
        case 401:
          sessionStorage.setItem("currentHref", to.fullPath);
          next('/authorization/cb');
          break;
        case 403:
          window.location.href = process.env.VUE_APP_AUTHORIZATION + "/v1/stay/login";
            break;
        default:
          next()
      }
    })
  }
});

router.afterEach((to, from) => {
  if (from.path === "/authorization/cb" && to.path !== "/authorization/redirect") {
    history.pushState({}, "", "/authorization/redirect");
    window.location.href = to.fullPath;
  }
});

Vue.use(
  VueGtag,
  {
    config: { id: process.env.VUE_APP_GOOGLE_CODE }
  },
  router
);

export default router
